<template>
  <va-card title="Service items">
    <va-button
      :to="{ name: '1lk-service-edit'}"
    >
      Створити
    </va-button>
    <va-data-table
      :fields="fields"
      :data="items"
      no-pagination
    >
      <template slot="marker" slot-scope="props">
        <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
      </template>

      <template slot="translations" slot-scope="props">
        <va-badge color="info" :outline="!translation.status" v-for="(translation, index) in props.rowData.trans" :key="index">{{ translation.locale }}</va-badge>
      </template>

      <template slot="toggle" slot-scope="props">
        <va-toggle
          small
          v-on:input="togglePublished(props.rowData.id)"
          v-model="props.rowData.published"
        />
      </template>

      <template slot="toggle2" slot-scope="props">
        <va-toggle
          small
          v-on:input="toggleMenuItem(props.rowData.id)"
          v-model="props.rowData.is_menu_item"
        />
      </template>

      <template slot="actions" slot-scope="props">
        <va-button
          small
          color="info"
          :to="{ name: '1lk-service-edit', params: { id: props.rowData.id } }"
        >
          Редагувати
        </va-button>
        <va-button
          @click="remove(props.rowData.id)"
          small
          color="danger"
          class="ma-0">
          Видалити
        </va-button>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  data () {
    return {
      items: [],
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    fields () {
      return [{
        name: 'label',
        title: 'Label',
        width: '20%',
      },
      {
        name: 'alias',
        title: 'Alias',
        width: '25%',
      },
      {
        title: 'Menu Item',
        name: '__slot:toggle2',
        width: '10%',
      },
      {
        title: 'Опубліковано',
        name: '__slot:toggle',
        width: '10%',
      },
      {
        name: 'position',
        title: 'Позиція',
        width: '10%',
      },
      {
        title: 'Переклади',
        name: '__slot:translations',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    toggleMenuItem (id) {
      axios.put(`${process.env.VUE_APP_1LK_API_URL}/admin/service/${id}`, {
        is_menu_item: this.items.find((item) => item.id === id).is_menu_item ? 1 : 0,
      })
        .then(response => {
          this.showToast('Success')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    togglePublished (id) {
      axios.put(`${process.env.VUE_APP_1LK_API_URL}/admin/service/${id}`, {
        published: this.items.find((item) => item.id === id).published ? 1 : 0,
      })
        .then(response => {
          this.showToast('Success')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    remove (id) {
      if (confirm('Дійсно видалити?')) {
        axios.delete(`${process.env.VUE_APP_1LK_API_URL}/admin/service/${id}`)
          .then(response => {
            const idx = this.items.findIndex(u => u.id === id)
            this.items.splice(idx, 1)
            this.showToast('Success')
          })
          .catch(error => {
            console.log(error)
            this.showToast('Error')
          })
      }
    },
    fetch () {
      axios.get(`${process.env.VUE_APP_1LK_API_URL}/admin/service?lang=${this.locale}`)
        .then(response => {
          console.log(response.data)
          this.items = response.data
          this.items.forEach((item) => {
            item.published = !!item.published
            item.is_menu_item = !!item.is_menu_item
          })
        })
        .catch(error => {
          console.log(error.response)
        })
    },
  },
}
</script>

<style lang="scss">
</style>
